import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * ProtectedRoute restricts access to authenticated users, and optionally to admin users only.
 * @param {Object} props
 * @param {boolean} [props.adminOnly] - If true, only admin users can access this route.
 */
const ProtectedRoute = ({ adminOnly = false }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // Show nothing while checking authentication
  if (loading) {
    return null;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    const fromPath = `${location.pathname}${location.search || ''}`;
    return <Navigate to="/login" replace state={{ from: fromPath }} />;
  }

  // If adminOnly, check user.is_admin
  if (adminOnly && (!user || !user.is_admin)) {
    return <Navigate to="/" replace />; // Or a /not-authorized page
  }

  // If authenticated (and admin if required), render the child routes
  return <Outlet />;
};

export default ProtectedRoute; 